import { formatNumber } from '@/helpers';
import { MatchedGrantsSelectors } from '@/store/matchedGrants';
import { MatchedPFSelectors } from '@/store/matchedPF/matchedPF.selector';
import { useSelector } from 'react-redux';
export const useMatchedGrantsMetrics = () => {
    const { totalGrantsAmount, totalGrants } = useSelector(MatchedGrantsSelectors.makeCustomerGrantsMetrics);
    const { totalPFs, totalPFAmount } = useSelector(MatchedPFSelectors.makeMatchedPFMetrics);
    const totalCount = totalGrants + totalPFs;
    const totalAmount = totalGrantsAmount;
    const formattedTotalAmount = '$' + formatNumber(totalAmount);
    const totalAvg = totalGrants > 0 ? '$' + formatNumber(Math.round(totalAmount / totalGrants)) : '$0';
    return {
        totalGrants,
        totalGrantsAmount,
        totalPFs,
        totalPFAmount,
        totalCount,
        formattedTotalAmount,
        totalAvg,
    };
};
